import { CalendarDays, MapPin, Users } from "lucide-react";
import { Eyebrow, PageHero } from "@/components/site/bits";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES, STEPPERS } from "@/data/site";

export default function Steppers() {
    return (
        <main>
            <PageHero
                testid="steppers-hero"
                eyebrow="11th Steppers"
                title="11th Steppers Fellowship"
                sub="A Christ-centered community supporting individuals in sustained recovery through education, fellowship, and spiritual growth."
                image={IMAGES.framework}
            />
            <section className="bg-white">
                <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 py-20 sm:py-24 lg:grid-cols-2">
                    <Reveal className="flex justify-center">
                        <div className="rounded-2xl border border-[#C9A227]/30 bg-[#F9F8F3] p-10">
                            <img
                                src={STEPPERS.logo}
                                alt="11th Steppers Fellowship — a Christ-centered community for recovery and spiritual growth"
                                data-testid="steppers-logo"
                                className="w-64 sm:w-80"
                            />
                        </div>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <Eyebrow>Hallelujah</Eyebrow>
                        <h2 className="mt-3 text-2xl sm:text-3xl font-extrabold tracking-tight text-[#0B1F3A]">
                            A Community for Recovery & Spiritual Growth
                        </h2>
                        <p className="mt-5 max-w-xl text-base leading-relaxed text-[#4A5568]">
                            The 11th Steppers Fellowship gathers around the Eleventh Step — prayer and meditation —
                            building a Christ-centered community where sustained recovery is supported through
                            education, fellowship, and spiritual growth. All are welcome.
                        </p>
                        <div className="mt-8 space-y-4">
                            <p data-testid="steppers-meeting" className="flex items-start gap-3 text-base font-semibold text-[#0B1F3A]">
                                <CalendarDays className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A227]" />
                                {STEPPERS.meeting}
                            </p>
                            <p data-testid="steppers-location" className="flex items-start gap-3 text-base text-[#0B1F3A]">
                                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A227]" />
                                <span>
                                    <span className="font-semibold">{STEPPERS.place}</span>
                                    <br />
                                    <span className="text-[#4A5568]">{STEPPERS.address}</span>
                                </span>
                            </p>
                            <p className="flex items-start gap-3 text-base text-[#4A5568]">
                                <Users className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A227]" />
                                Open to anyone seeking recovery, fellowship, and spiritual growth.
                            </p>
                        </div>
                    </Reveal>
                </div>
            </section>
        </main>
    );
}
